import { INFLOW, OUTFLOW, compactUsd } from "@/cockpit/formatCockpit";

/** Single-direction magnitude bar (13F position value, Form 144 shares). */
export function MagnitudeBar({ value = 0, max = 1, color = INFLOW }) {
  const pct = Math.min(100, Math.max(0, max > 0 ? (Number(value) / max) * 100 : 0));
  return (
    <div className="flex-1 min-w-[4.5rem]">
      <div className="h-2 rounded-sm overflow-hidden" style={{ background: "var(--hoip-hover)" }}>
        <div style={{ width: `${pct}%`, height: "100%", background: color }} />
      </div>
    </div>
  );
}

/** Horizontal two-way split. Color plus ▲/▼ so direction is not color-only. */
export function FlowSplitBar({
  leftUsd = 0,
  rightUsd = 0,
  leftLabel = "▲ Buy",
  rightLabel = "▼ Sell",
  title,
}) {
  const tot = Math.max(1, Number(leftUsd) + Number(rightUsd));
  const leftPct = (Number(leftUsd) / tot) * 100;
  return (
    <div className="flex-1 min-w-[4.5rem]" title={title || `${leftLabel} ${compactUsd(leftUsd)} · ${rightLabel} ${compactUsd(rightUsd)}`}>
      <div className="h-2 rounded-sm overflow-hidden flex" style={{ background: "var(--hoip-hover)" }}>
        <div style={{ width: `${leftPct}%`, background: INFLOW }} />
        <div style={{ width: `${100 - leftPct}%`, background: OUTFLOW }} />
      </div>
      <div className="flex justify-between text-[8px] mt-0.5" style={{ color: "var(--hoip-text-tertiary)" }}>
        <span>{leftLabel}</span>
        <span>{rightLabel}</span>
      </div>
    </div>
  );
}
